// byClaude-start 2026-07-01 13:36:18
/** 状态机轮询间隔（毫秒） */
export const timeoutGap = 5000;
// byClaude-end 2026-07-01 13:36:18

export const CONSTANTS = {
  USERTOKEN: 'userToken',
};
